var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.prefixCls}-overview`,attrs:{"id":"aochenOverview"}},[_c('Separate',{attrs:{"title":"研发概述","desc":"R&D OVERVIEW"}}),_c('div',{class:`${_vm.prefixCls}-overview-content`},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }